<div class="flex flex-column flex-grow-1 container surface-card border-round-md">
  <cdk-virtual-scroll-viewport itemSize="21" class="h-full">
    <table class="table">
      <thead sortable-table-header [headers]="headers" (onSort)="changeSort($event)"></thead>

      <tr class="w-full h-3rem" *ngIf="!dataSource?.totalCount">
        <td colspan="8" style="text-align: center">{{ 'TABLE.CONTENT.NO_DATA_TABLE' | translate }}</td>
      </tr>

      <ng-container *cdkVirtualFor="let license of dataSource">
        <tr class="w-full h-3rem text-center cursor-pointer" (click)="openLicenseDetail(license)">
          <td>
            <div class="flex flex-column align-items-center gap-1">
              {{ license.productName }}
            </div>
          </td>
          <td>{{ 'DB.MODULE.' + license.module.moduleType.code | translate }}</td>
          <td>{{ 'DB.LICENSE_TYPES.CODE.' + license.licenseType.code | translate }}</td>
          <td>{{ license.licenseKey }}</td>
          <td>{{ license.validFrom | formatDate: 'P' : true }}</td>
          <td [class.text-red-500]="!!license.expired" [class.text-green-500]="!license.expired">
            {{ (!!license.expired ? 'LABELS.EXPIRED' : 'LABELS.ACTIVE') | translate }}
          </td>
          <td>{{ (!!license.offlineActivation ? 'LABELS.OFFLINE' : 'LABELS.ONLINE') | translate }}</td>
        </tr>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
</div>
